import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { AppointmentService } from 'src/app/services/appointment/appointment.service';
import { ForuscareService } from 'src/app/services/foruscare/foruscare.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

interface selectedAppointmentObj {
  eventEndDate: any;
  eventStartDate: any;
  accountId: number;
  appointmentId: string;
  created: any;
  eventName: any;
  mrn: any;
  orgId: any;
  orgName: any;
  patientId: any;
  patientRegistered: any;
  screeningEventId: any;
  tentativeEndTime: any;
  tentativeStartTime: any;
}

@Component({
  selector: 'app-reschedule',
  templateUrl: './reschedule.component.html',
  styleUrls: ['./reschedule.component.css']
})
export class RescheduleComponent implements OnInit {

  modalRef: BsModalRef;

  @Input('screeningCenters') screeningCenters = [];
  @Input('selectedAppointment') selectedAppointment: selectedAppointmentObj;
  @Input('accountId') accountId;

  @Output() onCancel = new EventEmitter();
  @Output() onReschedule = new EventEmitter();

  datePickerConfig!: Partial<BsDatepickerConfig>;

  rescheduledScreeningCenter: any;

  availableDateDetails: any;
  datesForDisable: any;
  eventStartDate: any;
  eventEndDate: any;
  selectedDate: any;

  operatorList: any = [];
  selectedOperator: any;
  appointmentDetails = {
    date: '',
    time: '',
    operator: '',
    endTime: '',
    mrn: ''
  }

  showSlotTimeLable = false;
  avilableTimings: any[];

  disableSubmitButton = true;
  isOperatorAvailable = true;
  showOperatorLable = false;
  // showTooltip = true;
  isOperatorSelected = false;
  userId: any;
  isSlotTimeAvailable = false;
  selectedItems: any = {};
  isTimeSelected = false;
  showTooltip = false;

  constructor(private appointmentService: AppointmentService,
    private forusCareService: ForuscareService,
    private modalService: BsModalService) { }

  ngOnInit(): void {
    this.rescheduledScreeningCenter = this.selectedAppointment.orgId;
    this.getAvailableDates();
  }

  onCancelClick() {
    this.onCancel.emit("cancel-reschedule");
  }

  datePickerConfiguration() {
    this.datePickerConfig = Object.assign({},
      {
        isAnimated: true,
        dateInputFormat: 'DD-MMM-YYYY',
        showWeekNumbers: false,
        minDate: new Date(this.eventStartDate),
        maxDate: new Date(this.eventEndDate),
        showTodayButton: false,
        containerClass: 'theme-blue',
        datesDisabled: this.datesForDisable
      },
    );
  }

  getAvailableDates() {
    console.log(this.rescheduledScreeningCenter, "selected center");
    console.log(this.screeningCenters, "list")
    this.operatorList = [];
    this.avilableTimings = [];
    this.showSlotTimeLable = false;
    this.showOperatorLable = false;

    let eventDetails = {
      orgId: this.rescheduledScreeningCenter,
      eventId: this.selectedAppointment.screeningEventId
    }

    this.appointmentService.getAvailableDatesOfScreeningEventAndScreeningCenter(eventDetails)
      .subscribe((response: any) => {
        if (response !== null) {
          this.availableDateDetails = response.data;

          this.eventStartDate = this.selectedAppointment.eventStartDate;
          this.eventEndDate = this.selectedAppointment.eventEndDate;
          this.compareDate(this.eventStartDate);

          this.disableDates();

          this.datePickerConfiguration();
        }
      });

  }

  compareDate(date: any) {
    if (date !== null) {
      const currentDate = new Date();
      const startDateObject = new Date(date);
      const CurrentDateOnly = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
      const startDateOnly = new Date(startDateObject.getFullYear(), startDateObject.getMonth(), startDateObject.getDate());

      if (CurrentDateOnly > startDateOnly) {
        this.eventStartDate = currentDate;
      } else {
        this.eventStartDate = this.eventStartDate;
      }
    }
  }

  disableDates() {
    var datesToDisable = [];
    var obj = this.availableDateDetails;
    var result = Object.keys(obj).map((key) => [key, obj[key]]);
    for (let i = 0; i < result.length; i++) {
      if (result[i][1] == false) {
        let date = result[i][0];
        datesToDisable.push(new Date(date));
      }
    }
    this.datesForDisable = datesToDisable;
  }


  onDateChange(date: any) {

    if (this.rescheduledScreeningCenter == null) {
      this.forusCareService.showNotification("Please Select the Screening Center", "danger");
      return;
    }

    if (date !== null) {
      this.selectedOperator = {};
      this.disableSubmitButton = true;
      this.selectedDate = date;
      let convertedDate = this.selectedDate.getFullYear() + '-' + (this.selectedDate.getMonth() < 9 ? "0" + (this.selectedDate.getMonth() + 1) : (this.selectedDate.getMonth() + 1)) + '-' + (this.selectedDate.getDate() < 10 ? "0" + (this.selectedDate.getDate()) : (this.selectedDate.getDate()));
      this.appointmentDetails.date = convertedDate;
      this.showSlotTimeLable = false;
      this.appointmentDetails.operator = '';
      this.appointmentDetails.time = '';
      this.avilableTimings = [];
      this.getSlotsbyOrgId(this.rescheduledScreeningCenter);
    }
  }

  getSlotsbyOrgId(orgId: any) {
    var d = new Date();
    var currentTime = (d.getHours() < 10 ? "0" + d.getHours() : d.getHours()) + ":" + (d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes()) + ':' + (d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds());
    let slotDate = {
      appointmentDate: this.appointmentDetails.date + " " + currentTime,
    }
    this.operatorList = [];
    this.appointmentService.getSlotsbyOrgId(orgId, slotDate)
      .subscribe((response: any) => {
        if (response !== null && response.data.length > 0) {
          this.isOperatorAvailable = true;
          this.showOperatorLable = true;
          this.operatorList = response.data;
          this.onSelectoperator(this.operatorList[0].fullName, 0, this.operatorList[0].userId);
          this.selectedAppointment.orgName = this.operatorList[0].orgName;
        } else {
          this.isOperatorAvailable = false;
          this.showOperatorLable = false;

        }
      });
  }

  onSelectoperator(name: any, id: any, userId: any) {
    this.showTooltip = true;
    setTimeout(() => {
      this.showTooltip = false;
    }, 3000);
    this.disableSubmitButton = true;
    this.userId = userId;
    this.selectedOperator = {};
    this.selectedOperator[id] = name;
    this.isOperatorSelected = true;
    this.appointmentDetails.operator = name;
    this.getSlotTimings();
  }

  isSelectedOperator(item: any, id: any) {
    if (this.selectedOperator !== undefined) {
      return this.selectedOperator[id] && this.selectedOperator[id] === item.fullName;
    }
  }

  getSlotTimings() {
    var d = new Date();
    var currentTime = (d.getHours() < 10 ? "0" + d.getHours() : d.getHours()) + ":" + (d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes()) + ':' + (d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds());
    let slotDetails = {
      appointmentDate: this.appointmentDetails.date + " " + currentTime,
      userId: this.userId
    }
    this.appointmentService.getSlotTimings(slotDetails)
      .subscribe((response: any) => {
        if (response !== null) {
          let data = response.data;

          if (data.slotResponseOutput !== null && data.slotResponseOutput?.length > 0) {
            this.isSlotTimeAvailable = true;
          } else {
            this.isSlotTimeAvailable = false;
          }

          this.showSlotTimeLable = true;
          this.avilableTimings = data.slotResponseOutput;
        }
      })
  }

  onSelectSlot(slot: any, id: any) {
    this.selectedItems = {};
    this.selectedItems[id] = slot;
    this.disableSubmitButton = false;
    this.isTimeSelected = true;
    this.appointmentDetails.time = this.convertTime12to24(slot);
    console.log(this.appointmentDetails.time, "selected slot");
  }

  isSelectedItem(item: any, id: any) {
    if (this.selectedItems !== undefined) {
      return this.selectedItems[id] && this.selectedItems[id] === item.slotHours;
    }
  };

  convertTime12to24(time12h: any) {
    const [time, modifier] = time12h.split(' ');
    let [hours, minutes] = time.split(':');
    return `${hours}:${minutes}:00`;
  }

  tConvert(time: any) {
    // Check correct time format and split into components
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) { // If time format correct
      time = time.slice(1);  // Remove full string match value
      time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    time[0] = time[0] < 10 ? "0" + time[0] : time[0];
    return time[0] + time[1] + time[2] + " " + time[5]; // return adjusted time or original string
  }

  onConfirmReschedule(content: TemplateRef<any>) {
    const config = {
      class: 'modal-lg'
    };
    this.modalRef = this.modalService.show(content, config);
  }

  rescheduleAppointment() {
    let appointmentId = this.selectedAppointment.appointmentId;
    let rescheduleDetails = {
      userId: this.userId,
      orgId: this.rescheduledScreeningCenter,
      accountId: this.accountId,
      tentativeStartTime: this.appointmentDetails.date + " " + this.appointmentDetails.time
    }
    this.appointmentService.rescheduleAppointment(appointmentId, rescheduleDetails)
      .subscribe((response: any) => {
        if (response.errorCode == 200) {
          this.forusCareService.showNotification("Appointment Rescheduled Successfully", "success")
          // this.registrationService.isAppointmentCompleted = true;
          let dateTime = response.data.tentativeStartTime.split(" ");
          this.appointmentDetails.date = dateTime[0];
          this.appointmentDetails.time = dateTime[1];
          this.appointmentDetails.mrn = response.data.mrn;
          this.appointmentDetails.time = this.tConvert(this.appointmentDetails.time);
          this.onReschedule.emit("reschedule_completed");
          // this.patientInfo.venue = response.data.orgVenue;
          // this.userData.orgName = response.data.orgName;
        } else if (response.errorCode == 409) {
          this.forusCareService.showNotification("Appointment already booked for requested slot, please select different timings.", "danger");
          this.disableSubmitButton = true;
          this.showSlotTimeLable = false;
          this.selectedOperator = {};
        } else {
          this.forusCareService.showNotification("Something went wrong, Please try again later.", "danger");
        }
      })
  }

}
